/**
 * Search Console proof cases — unedited GSC exports from live client accounts.
 *
 * Lives here rather than inside a page because two surfaces render it: the
 * Blogger Outreach landing page and the homepage proof module. One source of
 * truth means the figures can't drift apart between them.
 */

const IMG = "/images/blogger-outreach";

export interface GscCase {
  label: string;
  shot: string;
  alt: string;
  title: string;
  clicks: string;
  impressions: string;
  position: string;
  window: string;
  /** Short version, shown on the card. */
  body: string;
  /** Longer explanation, shown when the card is opened. */
  detail: string;
  /** Full write-up, linked from the expanded view. */
  href?: string;
}

export const GSC_CASES: GscCase[] = [
  {
    label: "HEALTHCARE · UNITED KINGDOM",
    shot: `${IMG}/gsc-01.png`,
    alt: "Google Search Console: 14.6K clicks, 1.53M impressions, average position 6.5",
    title: "Leads up 600% in six months",
    // Clicks, impressions and average position are the figures visible in the
    // screenshot itself, so they have to stay as they are. Leads and bookings
    // come from the clinic's own booking system — a GSC export never shows
    // those, so the two sit alongside each other rather than contradicting.
    clicks: "14.6K", impressions: "1.53M", position: "6.5", window: "6 months to turn",
    body: "A UK minor surgery clinic doing 30–40 organic clicks a month. Six months of the Full-Stack Search Method™ took it past 100 clicks a day — and leads up 600%.",
    detail: "Bookings rose 500% alongside leads, and average position moved from 19.2 to 6.8 — onto page one, where the majority of patient clicks happen. The growth wasn't a spike: clicks, leads and bookings improved month on month and held the new level.",
    href: "/client-stories/minor-surgery-clinic",
  },
  {
    label: "6 MONTHS · ESTABLISHED SITE",
    shot: `${IMG}/gsc-02.png`,
    alt: "Google Search Console: 11.3K clicks, 2.53M impressions over 6 months",
    title: "From ~40 to 120+ clicks a day",
    clicks: "11.3K", impressions: "2.53M", position: "8.1", window: "6 months",
    body: "Traffic was sliding until links started landing in March. Clicks roughly tripled off the floor and held the new level month after month.",
    detail: "An established site losing ground to better-linked competitors. We rebuilt authority to the pages that were slipping, prioritizing niche-relevant placements over raw DR — the recovery held rather than spiking and fading.",
  },
];
